export default __webpack_public_path__ + "static/media/ring.54cad9f9.mp3";